import React, { useState, useEffect, useMemo } from 'react';
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import { Container, Title, TitleRow, Message, Button, NoItems, MessageIcon, UserName, NumOf } from './MessagesList.styles';
import T, { Translate } from '../../i18n/i18n';
import { getMessages } from '../../../services/messages';

export default () => {

    const [expanded, setExpanded] = useState(localStorage.getItem('config.profileMessagesExpand') === '1');
    const [messages, setMessages] = useState([]);

    const messagesUnread = useSelector(state => state.messagesState.unread);

    const history = useHistory();

    useEffect(()=>{
        setMessages(Object.values(messagesUnread).filter(m => m.unread));
    }, [messagesUnread]);

    const handleExpand = () => {
        setExpanded(e => {
            localStorage.setItem('config.profileMessagesExpand', !e ? '1' : '0');
            return !e;
        })
    }

    const goToMessagesPage = () => {
        history.push('/home/messages');
    }
    

    return <Container>
        <TitleRow onClick={()=>{handleExpand()}} className={expanded ? 'expanded' : ''}>
            <Title><T value="messages.title" /></Title>    
            {expanded ? 
                <Button color="#be5cde" title={Translate("messages.seeAll")} icon={"\\F028C"} onClick={goToMessagesPage} /> 
            : 
                <NumOf>{messages.length} <T value="messages.unread" /></NumOf> }
        </TitleRow>
        { expanded ? <>
            { messages.length ? messages.map((m,i) => <Message key={i} onClick={goToMessagesPage}>
                <MessageIcon>{m.unread}</MessageIcon>
                <UserName>{m.name}</UserName>
            </Message>) : <NoItems>
                <T value="messages.noMessagesList" />
            </NoItems> }
        </> : null }
    </Container>
};